export const generateID = () => {
  const a = Math
    .random()
    .toString(36)
    .substring(2, 15)

  const b = Math
    .random()
    .toString(36)
    .substring(2, 15)

  return a + b;
};

export const randomFrom = (values) => values[Math.floor(Math.random() * values.length)]

export const neighbouringNumbersTo = (number) => {
  let neighbourList = []

  for (let i = (number - 1); i > (number - 6) && (i > 1); i--) {
    neighbourList.push(i)
  }

  for ( let i = (number + 1); neighbourList.length < 10; i++) {
    neighbourList.push(i)
  }

  return neighbourList
}

export const randomNumber = () => Math.floor(Math.random() * 10) + 2
